import React from 'react';
import { useFieldHelper, FieldProps } from 'framework/ui/field';
import AgreementStatusChip from '../components/AgreementStatusChip';
import { AGREEMENT_STATUS } from '../../constants';

const AgreementStatusField = ({ source }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const status = getValue() as keyof typeof AGREEMENT_STATUS;

  return <AgreementStatusChip status={status} />;
};

export default AgreementStatusField;
